/**
 *
 * FBAddNewSection
 *
 */

import React, { memo, useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// antd component
import { Tooltip, Checkbox } from "antd";

// icons
import CustomIcons from "components/CustomIcons";

import { ArrayEquals } from "utils/helpers/helper.general";

function FBAddNewSection({
  // main
  buildFormValid,
  // states
  method,
  initialValues,
  values,
  parentTypes,
  // actions
  onChange,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames("tcf-fb-add-new-section", className);
  const { t } = useTranslation();

  const init = {
    forms: null,
    appointments: null,
    documents: null,
    discussion: null,
  };

  const initCheckboxButton = [
    {
      // 1
      key: "appointments",
      value: "appointments",
      label: t("global.formTypes.appointments"),
      title: t("global.formTypes.appointments"),
      icon: "calendar",
    },
    {
      // 2
      key: "forms",
      value: "forms",
      label: t("global.formTypes.forms"),
      title: t("global.formTypes.forms"),
      icon: "check-present",
    },
    {
      // 3
      key: "documents",
      value: "documents",
      label: t("global.formTypes.documents"),
      title: t("global.formTypes.documents"),
      icon: "document",
    },
    {
      // 4
      key: "discussion",
      value: "discussion",
      label: t("global.formTypes.discussion"),
      title: t("global.formTypes.discussion"),
      icon: "comments",
    },
  ];

  const prepearValToSet = useCallback(
    vals => {
      const values = [];
      if (!!vals && Object.keys(vals)?.length > 0) {
        for (const initKey in initialValues) {
          const val = vals[initKey];
          if (
            !!val &&
            Object.keys(val)?.length > 0 &&
            initKey != "discussion"
          ) {
            values.push(initKey);
          }
        }
      }
      // Only for Discussion Section
      const hasD = parentTypes?.find(el => el == "discussion");
      if (!!hasD) {
        values.push("discussion");
      }

      return values;
    },
    [initialValues, parentTypes],
  );

  const [checkedButtons, setCheckedButtons] = useState(parentTypes || []);

  useEffect(() => {
    if (!!parentTypes) {
      const isEqual = ArrayEquals(parentTypes, checkedButtons);
      if (!isEqual) {
        setCheckedButtons(parentTypes);
        onChange(parentTypes);
      }
    }
  }, [parentTypes]);

  const onChangeCallback = useCallback(
    list => {
      if (buildFormValid) {
        setCheckedButtons(list);
        !!onChange && onChange(list);
      }
    },
    [onChange, buildFormValid],
  );

  return (
    method != "onlyRead" && (
      <div
        className={
          childClassNames +
          ` ${
            !buildFormValid && checkedButtons?.length > 0
              ? "not-valid-build-form"
              : ""
          }`
        }
      >
        <h4 className="tcf-fb-add-new-title">{t("news.addSection")}</h4>
        {!buildFormValid && checkedButtons?.length > 0 ? (
          <Tooltip
            placement="top"
            title={t("news.infoAttachments")}
            color="#005D9F"
            trigger="click"
          >
            <Checkbox.Group
              defaultValue={!!initialValues && prepearValToSet(initialValues)}
              value={checkedButtons}
              onChange={onChangeCallback}
              className="tcf-fb-add-new__group"
              disabled={!buildFormValid && checkedButtons?.length > 0}
            >
              {initCheckboxButton?.map((button, index) => {
                return (
                  <Checkbox
                    key={`tcf-fb-add-new-${index}-${button?.key}`}
                    checked={() => {
                      const checkBtn = checkedButtons.find(
                        el =>
                          el == (button?.value || button?.key || button?.label),
                      );
                      return checkBtn;
                    }}
                    value={button?.value || button?.key}
                    className={`tcf-fb-add-new__button ${button?.key}`}
                    //disabled={button?.key != 'documents'}
                  >
                    {button?.icon && (
                      <CustomIcons
                        className="tcf-fb-add-new__icon"
                        type={button?.icon}
                      />
                    )}
                    <span className="tcf-fb-add-new__label">
                      {button?.title || button?.label}
                    </span>
                  </Checkbox>
                );
              })}
            </Checkbox.Group>
          </Tooltip>
        ) : (
          <Checkbox.Group
            defaultValue={!!initialValues && prepearValToSet(initialValues)}
            value={checkedButtons}
            onChange={onChangeCallback}
            className="tcf-fb-add-new__group"
            disabled={!buildFormValid && checkedButtons?.length > 0}
          >
            {initCheckboxButton?.map((button, index) => {
              return (
                <Checkbox
                  key={`tcf-fb-add-new-${index}-${button?.key}`}
                  checked={() => {
                    const checkBtn = checkedButtons.find(
                      el =>
                        el == (button?.value || button?.key || button?.label),
                    );
                    return checkBtn;
                  }}
                  value={button?.value || button?.key}
                  className={`tcf-fb-add-new__button ${button?.key}`}
                  //disabled={button?.key != 'documents'}
                >
                  {button?.icon && (
                    <CustomIcons
                      className="tcf-fb-add-new__icon"
                      type={button?.icon}
                    />
                  )}
                  <span className="tcf-fb-add-new__label">
                    {button?.title || button?.label}
                  </span>
                </Checkbox>
              );
            })}
          </Checkbox.Group>
        )}
      </div>
    )
  );
}

FBAddNewSection.defaultProps = {
  method: "new",
  initialValues: {
    forms: null,
    appointments: null,
    documents: null,
    discussion: null,
  },
  parentTypes: [],
};
FBAddNewSection.propTypes = {
  method: PropTypes.oneOf(["edit", "onlyRead", "preview", "new"]).isRequired,
  onChange: PropTypes.func,
};

export default memo(FBAddNewSection);
